import React, { Component } from 'react'
import { Timeline } from 'antd'
import { IDynamicTimelineItem } from '../../interfaces/IDynamicTimeline'
import { normalizeToArray } from '../../helpers/field-mapping.helper'

type DynamicTimelineProps = {
  items: Record<any, IDynamicTimelineItem>,
  loading?: boolean
}

export default class DynamicTimeline extends Component<DynamicTimelineProps> {

  private renderTimeline = () => {
    const { items } = this.props

    const arr = normalizeToArray(items)
    if (arr) {
      return arr.sort((a, b) => a.value.order - b.value.order).map(item => {
        return (
          <Timeline.Item
            key={`timeline-item-${item.map_type}`}
            color={item.value.color || 'blue'}
          >
            <b>{item.value.label}</b> {item.value.value !== undefined ? item.value.render(item.value.value) : null}
          </Timeline.Item>
        )
      })
    }
  }

  render() {
    const { loading } = this.props

    return (
      <Timeline pending={loading ? 'Processing' : null}>
        {this.renderTimeline()}
      </Timeline>
    )
  }
}
